module.exports = __webpack_public_path__ + "static/media/aws-logo.c7401f52.png";